import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { Carousel as Slider, Tag } from 'antd'
import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const Sliders = styled(Slider)`
  .ant-carousel .slick-slide {
    text-align: center;
    line-height: 19px;
    background: ${COLORS.WHITE};
    overflow: hidden;
  }

  .ant-carousel .slick-slide div {
    color: ${COLORS.GREY_T_20};
  }
`
export const CarouselFlex = styled(Flex)`
  gap: 20px;
`

export const HeaderFlex = styled(Flex)`
  gap: 10px;
  margin: 0 0 15px 40px;
  width: 100%;
`

export const IntervierFlex = styled(Flex)`
  gap: 5px;
  width: 60%;
  height: 45px;
  background: ${COLORS.BLUE_T_97};
  padding: 10px;
  border: 1px solid ${COLORS.BLUE_T_80};
  border-radius: 10px;
  cursor: pointer;
`
export const InterviewerName = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_20};
`
export const GroupFlex = styled(Flex)`
  gap: 35px;
  margin: 25px 0;
`
export const TimeDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${props => (props.font ? props.font : `${FONT.F_XS}`)};
  line-height: 15px;
  color: ${COLORS.GREY_T_60};
  white-space: nowrap;
`
export const GroupIdDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XS};
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
  margin-bottom: 3px;
  height: 25px;
  font-family: Plus Jakarta Sans;
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: left;
`

export const BreakDiv = styled.div`
  width: Fill (540px);
  height: Hug (54px);
  padding: 15px;
  margin-top: 20px;
  border-radius: 10px;
  border: 1px;
  gap: 10px;
  background: linear-gradient(0deg, #fdede2, #fdede2),
    linear-gradient(0deg, #fefbf8, #fefbf8);
  display: flex;
  justify-content: center;
`
export const InterviewFlex = styled(Flex)`
  gap: 10px;
  width: 100%;
`
export const InterviewFlex1 = styled(Flex)`
  gap: 30px;
`
export const InterviewInfoFlex = styled(Flex)`
  padding: 20px 15px;
  border: 1px solid ${COLORS.GREY_T_90};
  width: 100%;
  border-radius: 10px;
`

export const InterviewInfoFlex2 = styled(Flex)`
  padding: 20px 15px;
  width: 100%;
`
export const AdjustIcon = styled.div`
  height: 50px;
  text-align: center;
  position: relative;
  background-color: ${COLORS.WHITE};
  padding: 18px;
  cursor: pointer;
  left: -2px;
`
export const RightArrowDiv = styled.div`
  height: 50px;
  min-width: 68px;
  text-align: center;
  position: relative;
  left: -26%;
  background-color: ${COLORS.WHITE};
  padding: 18px;
  cursor: pointer;
  z-index: '10';
`

export const CaroselDiv = styled.div`
  position: relative;
  width: 100%;
  left: -2%;
`
export const FooterFlex = styled(Flex)`
  gap: 10px;
`

export const BreakWrapper = styled(Flex)`
  gap: 10px;
  background: #fefbf8;
  border: 1px solid #fdede2;
  border-radius: 10px;
  height: 54px;
  padding-left: 10px;
  margin-bottom: 10px;
`
export const OutlineDiv = styled.div`
  height: 70px;
  padding-top: 10px;
`
export const CardText = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  color: ${COLORS.GREY_T_50_2};
  height: 25px;
`

export const StyledFlex = styled.div`
  padding: 5px 48px 5px 20px;

  width: 600px;
  height: 140px;
  border-radius: 10px;
  border: 1px solid #e6e7ea;

  box-shadow: 0px 2px 8px rgba(201, 201, 201, 0.1),
    inset 0px -1px 0px rgba(0, 0, 0, 0.05);
`

export const BreakText = styled(Flex)`
  font-weight: 600;
  font-size: 14px;
  color: #343e59;
`
export const TagWarapper = styled(Tag)`
  background: #ebecee;
  border-radius: 6px;
  align-items: center;
  padding: 3px 8px;
  font-weight: 500;
  font-size: 14px;
  color: #010e30;
`

export const TimeFlex = styled(Flex)`
  gap: 5px;
`

export const RightArrow = styled(RightOutlined)`
  cursor: pointer;
  color: #cccfd6;
`

export const LeftArrow = styled(LeftOutlined)`
  cursor: pointer;
  color: #cccfd6;
`
